import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance';

const columns = [
    {
        name: 'Company',
        selector: (row) => row.company,
    },
    {
        name: 'Facebook',
        selector: (row) =>
            row.facebook ? (
                <a href={row.facebook} target="_blank" rel="noopener noreferrer">
                    {row.facebook}
                </a>
            ) : (
                ''
            ),
    },
    {
        name: 'Instagram',
        selector: (row) =>
            row.instagram ? (
                <a href={row.instagram} target="_blank" rel="noopener noreferrer">
                    {row.instagram}
                </a>
            ) : (
                ''
            ),
    },
    {
        name: 'Twitter',
        selector: (row) =>
            row.twitter ? (
                <a href={row.twitter} target="_blank" rel="noopener noreferrer">
                    {row.twitter}
                </a>
            ) : (
                ''
            ),
    },
    {
        name: 'Linkedin',
        selector: (row) =>
            row.linkedin ? (
                <a href={row.linkedin} target="_blank" rel="noopener noreferrer">
                    {row.linkedin}
                </a>
            ) : (
                ''
            ),
    },
];

const SocialList = () => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [pages, setPages] = useState(1)
    const [limit, setLimit] = useState(50)
    const [totalRows, setTotalRows] = useState(0)

    const fetchBrandingData = async () => {
        setIsLoading(true)
        try {
            const response = await axiosAuthInstance.get('company-branding/list', {
                page: pages,
                limit: limit,
            })
            if (response.status === 200) {
                const transformedData = response.data.result.docs
                setData(transformedData)
                setTotalRows(response.data.result.totalDocs)
            }
        } catch (error) {
            console.log("error", error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchBrandingData();
    }, []);

    const handlePageChange = (newPage) => {
        setPages(newPage)
    }

    const handleLimitPerPageChange = (newLimit) => {
        setLimit(newLimit)
        setPages(1)
    }

    const openSocialLinks = (platform) => {
        data.forEach((company) => {
            const link = company[platform];
            if (link) {
                window.open(link, '_blank');
            }
        });
    };

    if (isLoading) {
        return <div>Loading...</div>
    }

    return (
        <>
            <div className='border-b pb-2'>
                <h1 className='text-2xl'>Social Media List</h1>
            </div>
            <div className='flex gap-4 items-center justify-start my-3'>
                <button
                    className="bg-primary text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600"
                    onClick={() => openSocialLinks('facebook')}
                >
                    Open All Facebook
                </button>

                <button
                    className="bg-primary text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600"
                    onClick={() => openSocialLinks('instagram')}
                >
                    Open All Instagram
                </button>

                <button
                    className="bg-primary text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600"
                    onClick={() => openSocialLinks('twitter')}
                >
                    Open All Twitter
                </button>

                <button
                    className="bg-primary text-white px-4 py-2 rounded focus:outline-none hover:bg-orange-600"
                    onClick={() => openSocialLinks('linkedin')}
                >
                    Open All Linkedin
                </button>
            </div>

            <DataTable
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={limit}
                paginationRowsPerPageOptions={[10, 20, 30]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitPerPageChange}
            />
        </>
    );
};

export default SocialList;
